import React from 'react'
import PropTypes from 'prop-types'

import Progressbar from 'Pods/Shared/Progressbar'

function NextLevelBar({ currentRep, nextRep }) {
  return (
    <div className="tooltip-progress">
      <div className="tooltip-progress__title">
        {currentRep} / {nextRep}
      </div>
      <Progressbar
        value={currentRep}
        maxValue={nextRep}
        labelSize="label-none"
        barColor="is-dark"
      />
    </div>
  )
}

NextLevelBar.propTypes = {
  currentRep: PropTypes.number.isRequired,
  nextRep: PropTypes.number.isRequired,
}

export default NextLevelBar
